import { TsDOM as q} from '@/scripts/core/TsDOM'
import { ProductForm } from '@/scripts/product/product-form'
import { ProductInfo } from '@/scripts/product/product-info'
import { ProductModal } from '@/scripts/product/product-modal'
import { MediaGallery } from '@/scripts/product/media-gallery'
import { VariantSelects } from '@/scripts/theme/variant-selects';
import { VariantRadios } from '@/scripts/theme/variant-radios';
import { ProductRecommendations } from '@/scripts/theme/product-recommendations';
import { QuickOrderList } from '@/scripts/product/quick-order-list';
import { ActiveIngredients } from '@/scripts/product/active-ingredients'
import { SkincareProtocols } from '@/scripts/product/skincare-protocols'
import { VideoTestimonialsCarousel } from '@/scripts/product/video-testimonials-carousel'

q.safeDefineElement(ProductInfo)
q.safeDefineElement(ProductForm)
q.safeDefineElement(ProductModal)
q.safeDefineElement(MediaGallery)
q.safeDefineElement(VariantSelects)
q.safeDefineElement(VariantRadios)
q.safeDefineElement(ProductRecommendations)
q.safeDefineElement(QuickOrderList)
q.safeDefineElement(ActiveIngredients)
q.safeDefineElement(SkincareProtocols)
q.safeDefineElement(VideoTestimonialsCarousel)
